<template>
   <div class="reservations">
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-md-12">
			<div class="card">
				<div class="card-header bg-white border-0">
					<div class="row align-items-center">
						<div class="col-8">
							<h3 class="mb-0 text-left">{{$t("forms.reservation.myReservations")}}</h3>
						</div>
                        <div class="col-4 text-right">
							<router-link class="btn btn-sm btn-success" to="/">{{$t('actions.newBooking')}}</router-link>
						</div>
					</div>
					<hr>
				</div>
                <div class="card-body">
                    <div v-show="isLoading">
                        <div class="spinner-border text-warning" role="status"><span class="sr-only">Loading...</span></div>
                    </div>
                    <div class="row justify-content-center" v-show="!isLoading">
                        <div class="col-lg-12 col-md-12">
                            <!--  Customer Id | From | No. Drivers | Status | Actions -->
                            <table class="table services-table">
                            <thead class="thead-light">
                                <tr>
                                    <th class="bt-0">#</th>
                                    <th style="max-width: 150px;">{{$t("forms.reservation.status")}}</th>
                                    <th scope="col">{{$t("forms.reservation.carNumber")}}</th>
                                    <th scope="col">{{$t("forms.reservation.pickupDateTime")}}</th>  
                                    <th scope="col">{{$t("forms.reservation.from")}}</th>             
                                    <th scope="col">{{$t("forms.reservation.service")}}</th>
                                    <th scope="col">{{$t("forms.reservation.price")}}</th> 
                                    <th scope="col"></th> 
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in reservations" :key="item.guid">
                                    <td scope="row">{{item.customerId}}</td>
                                    <td style="max-width: 150px;">
                                        <span :class="getItemStyle(item)" >
                                            {{$t(`forms.reservation.reservationStatusText.${item.status.toLowerCase()}`)}}
                                        </span>
                                    </td>
                                    <td>{{item.numberOfCars}}</td>
                                    <td>{{item.pickupDateTimeMoment.format('DD MMM @ hh:mm')}}</td>
                                    <td>{{item.from}}</td>
                                    <td>{{item.carType}}</td>
                                    <td style="white-space: nowrap;">
                                        <span v-show="item.totalPrice>0">{{item.totalPrice | round(2, true)}} {{item.currency}}</span>
                                        <span v-show="item.totalPrice == 0"> - </span>
                                    </td>
                                    <td style="white-space: nowrap;">
                                        <router-link :to="{ name: 'reservationDetails', params: {id: item.guid}}" class="btn btn-sm btn-primary mr-2">{{$t('actions.details')}}</router-link>
                                        <!-- <button class="btn btn-sm btn-danger" v-show="item.canCancel">{{$t('actions.cancel')}}</button> -->
                                    </td>
                                </tr>
                            </tbody>
                            </table> 
                        </div>        
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import { round } from "../utils/filters.js";
import moment from 'moment';

export default {
    data() {
        return {
            isLoading: true,
            reservations: [],		
        };
    },
    computed: {

    },
    filters: {
        round: round
    },
    created() {
        this.getClientReservations().then(result=>{
            console.log("getClientReservations result:", result);
            
            result.forEach(item => {
                item.pickupDateTimeMoment = moment(item.pickupDateTime);
                console.log(item);
            });

            this.reservations = result
            this.isLoading = false;
        });

	// this.getUserProfile().then(result=>{		
	// 	this.email = result.email;
	// 	this.firstName = result.firstName;
	// 	this.lastName = result.lastName;
	// 	this.phone = result.phoneNumber;
	// 	this.defaultCar = result.defaultCar;
	// 	this.currency = result.currency;
	// 	this.instructionsForPlanner = result.instructionsForDispatcher;
	// 	this.instructionsForDriver = result.instructionsForDriver;
	// 	if(result.otherCars)
	// 		this.otherCars = result.otherCars.join(", ");
	// 	if(result.subscription)
	// 		this.subscription = result.subscription;
	// 	if(result.remainingCredit)
	// 		this.remainingCredit = result.remainingCredit;
	// 	if(result.pickupAddress)
	// 		this.address = result.pickupAddress.formatterAddress;
	// 	this.isLoading = false;
	// });
  },
  methods: {
    getItemStyle (item) {
        return {
            'text-danger': item.status.toLowerCase() == 'cancelled',
            'text-success': item.status.toLowerCase() == 'confirmed' || item.status.toLowerCase() == 'in progress'
        }
    },
    ...mapActions("account", ["getClientReservations"]),
  }
}
</script>

<style>
    .services-table tbody td {
        font-size: 14px;
        vertical-align: middle;
    }
</style>